export const sidemenu = {
  "defaultMenuKey": 0,
  "items": [
    {
      "menuKey": 14620000,
      "parentMenuKey": null,
      "label": "Home",
      "desc": "",
      "iconStyle": "",
      "url": "",
      "moduleKey": 24,
      "submenu": [
        {
          "menuKey": 14630000,
          "parentMenuKey": null,
          "label": "Report Card Data",
          "desc": "Reports depicting local report card measures.",
          "iconStyle": "fas fa-file-chart-line",
          "url": "",
          "moduleKey": 24,
          "submenu": [
            {
              "menuKey": 14630100,
              "parentMenuKey": 14630000,
              "label": "Discipline",
              "desc": "Reports about Disciplinary incidents.",
              "iconStyle": "fas fa-chart-bar",
              "url": "",
              "moduleKey": 24,
              "submenu": [
                {
                  "menuKey": 14630101,
                  "parentMenuKey": 14630100,
                  "label": "Discipline Occurrences (Attending Building, School Level - Prior to 2018)",
                  "desc": "Incident counts by school by discipline type and reason.",
                  "iconStyle": "fas fa-chart-bar",
                  "url": "/report/report-card-data-school-discipline-occurrences-attending-school-2017-",
                  "moduleKey": 24,
                  "submenu": []
                },
                {
                  "menuKey": 14630102,
                  "parentMenuKey": 14630100,
                  "label": "Discipline Occurrences (Attending Building, District Level - Prior to 2018)",
                  "desc": "Incident counts by district by discipline type and reason.",
                  "iconStyle": "fas fa-chart-bar",
                  "url": "/report/report-card-data-district-discipline-occurrences-attending-school-2017",
                  "moduleKey": 24,
                  "submenu": []
                },
                {
                  "menuKey": 14630103,
                  "parentMenuKey": 14630100,
                  "label": "Discipline Occurrences (Attending Building, State Level - Prior to 2018)",
                  "desc": "Incident counts for state by discipline type and reason.",
                  "iconStyle": "fas fa-chart-bar",
                  "url": "/report/report-card-data-state-discipline-occurrences-attending-school-2017",
                  "moduleKey": 24,
                  "submenu": []
                },
                {
                  "menuKey": 14630104,
                  "parentMenuKey": 14630100,
                  "label": "Discipline Occurrences (Incident Location, School Level)",
                  "desc": "Incident counts by school by discipline type and reason.",
                  "iconStyle": "fas fa-chart-bar",
                  "url": "/report/report-card-data-school-discipline-occurrences-incident-location-2018",
                  "moduleKey": 24,
                  "submenu": []
                },
                {
                  "menuKey": 14630105,
                  "parentMenuKey": 14630100,
                  "label": "Discipline Occurrences (Incident Location, District Level)",
                  "desc": "Incident counts by district by discipline type and reason.",
                  "iconStyle": "fas fa-chart-bar",
                  "url": "/report/report-card-data-district-discipline-occurrences-incident-location-2018",
                  "moduleKey": 24,
                  "submenu": []
                },
                {
                  "menuKey": 14630106,
                  "parentMenuKey": 14630100,
                  "label": "Discipline Occurrences (Incident Location, State Level)",
                  "desc": "Incident counts for state by discipline type and reason.",
                  "iconStyle": "fas fa-chart-bar",
                  "url": "/report/report-card-data-state-discipline-occurrences-incident-location-2018",
                  "moduleKey": 24,
                  "submenu": []
                }
              ]
            },
            {
              "menuKey": 14630200,
              "parentMenuKey": 14630000,
              "label": "Enrollment",
              "desc": "Reports about Student Enrollment.",
              "iconStyle": "fas fa-users-class",
              "url": "",
              "moduleKey": 24,
              "submenu": [
                {
                  "menuKey": 14630201,
                  "parentMenuKey": 14630200,
                  "label": "School Enrollment by Student Demographic",
                  "desc": "Enrollment for a school as reported on the report card by demographic.",
                  "iconStyle": "fas fa-users-class",
                  "url": "/report/report-card-data-school-enrollment-by-student-demographic",
                  "moduleKey": 24,
                  "submenu": []
                },
                {
                  "menuKey": 14630202,
                  "parentMenuKey": 14630200,
                  "label": "District Enrollment by Student Demographic",
                  "desc": "Enrollment for a district as reported on the report card by demographic.",
                  "iconStyle": "fas fa-users-class",
                  "url": "/report/report-card-data-district-enrollment-by-student-demographic",
                  "moduleKey": 24,
                  "submenu": []
                },
                {
                  "menuKey": 14630203,
                  "parentMenuKey": 14630200,
                  "label": "State Enrollment by Student Demographic",
                  "desc": "Enrollment for the state as reported on the report card by demographic.",
                  "iconStyle": "fas fa-users-class",
                  "url": "/report/report-card-data-state-enrollment-by-student-demographic",
                  "moduleKey": 24,
                  "submenu": []
                }
              ]
            },
            {
              "menuKey": 14630300,
              "parentMenuKey": 14630000,
              "label": "Financial",
              "desc": "Reports about Expenditures and Revenues.",
              "iconStyle": "fas fa-file-invoice-dollar",
              "url": "",
              "moduleKey": 24,
              "submenu": [
                {
                  "menuKey": 14630301,
                  "parentMenuKey": 14630300,
                  "label": "School Expenditures Detail",
                  "desc": "School expenditures.",
                  "iconStyle": "fas fa-file-invoice-dollar",
                  "url": "/report/report-card-data-school-expenditures-detail",
                  "moduleKey": 24,
                  "submenu": []
                },
                {
                  "menuKey": 14630302,
                  "parentMenuKey": 14630300,
                  "label": "District Expenditures Detail",
                  "desc": "District expenditures.",
                  "iconStyle": "fas fa-file-invoice-dollar",
                  "url": "/report/report-card-data-district-expenditures-detail",
                  "moduleKey": 24,
                  "submenu": []
                },
                {
                  "menuKey": 14630303,
                  "parentMenuKey": 14630300,
                  "label": "State Expenditures Detail",
                  "desc": "State expenditures.",
                  "iconStyle": "fas fa-file-invoice-dollar",
                  "url": "/report/report-card-data-state-expenditures-detail",
                  "moduleKey": 24,
                  "submenu": []
                }
              ]
            },
            {
              "menuKey": 14630400,
              "parentMenuKey": 14630000,
              "label": "Graduation",
              "desc": "Reports about High School Graduation Rates.",
              "iconStyle": "fas fa-user-graduate",
              "url": "",
              "moduleKey": 24,
              "submenu": [
                {
                  "menuKey": 14630401,
                  "parentMenuKey": 14630400,
                  "label": "School 4 Year Longitudinal Graduation Rate",
                  "desc": "Graduation Rate results by school and demographics for students in the 4-year graduation rate.",
                  "iconStyle": "fas fa-user-graduate",
                  "url": "/report/report-card-data-school-4-year-longitudinal-graduation-rate",
                  "moduleKey": 24,
                  "submenu": []
                },
                {
                  "menuKey": 14630402,
                  "parentMenuKey": 14630400,
                  "label": "District 4 Year Longitudinal Graduation Rate",
                  "desc": "Graduation Rate results by district and demographics for students in the 4-year graduation rate.",
                  "iconStyle": "fas fa-user-graduate",
                  "url": "/report/report-card-data-district-4-year-longitudinal-graduation-rate",
                  "moduleKey": 24,
                  "submenu": []
                },
                {
                  "menuKey": 14630403,
                  "parentMenuKey": 14630400,
                  "label": "State 4 Year Longitudinal Graduation Rate",
                  "desc": "Graduation Rate results for state by demographics for students in the 4-year graduation rate.",
                  "iconStyle": "fas fa-user-graduate",
                  "url": "/report/report-card-data-state-4-year-longitudinal-graduation-rate",
                  "moduleKey": 24,
                  "submenu": []
                },
                {
                  "menuKey": 14630404,
                  "parentMenuKey": 14630400,
                  "label": "School 5 Year Longitudinal Graduation Rate",
                  "desc": "Graduation Rate results by school and demographics for students in the 5-year graduation rate.",
                  "iconStyle": "fas fa-user-graduate",
                  "url": "/report/report-card-data-school-5-year-longitudinal-graduation-rate",
                  "moduleKey": 24,
                  "submenu": []
                },
                {
                  "menuKey": 14630405,
                  "parentMenuKey": 14630400,
                  "label": "District 5 Year Longitudinal Graduation Rate",
                  "desc": "Graduation Rate results by district and demographics for students in the 5-year graduation rate.",
                  "iconStyle": "fas fa-user-graduate",
                  "url": "/report/report-card-data-district-5-year-longitudinal-graduation-rate",
                  "moduleKey": 24,
                  "submenu": []
                },
                {
                  "menuKey": 14630406,
                  "parentMenuKey": 14630400,
                  "label": "State 5 Year Longitudinal Graduation Rate",
                  "desc": "Graduation Rate results for state by demographics for students in the 5-year graduation rate.",
                  "iconStyle": "fas fa-user-graduate",
                  "url": "/report/report-card-data-state-5-year-longitudinal-graduation-rate",
                  "moduleKey": 24,
                  "submenu": []
                },
                {
                  "menuKey": 14630407,
                  "parentMenuKey": 14630400,
                  "label": "School Graduate Count by School Year",
                  "desc": "Graduation counts by school and demographics for students.",
                  "iconStyle": "fas fa-user-graduate",
                  "url": "/report/report-card-data-school-graduate-count-by-school-year",
                  "moduleKey": 24,
                  "submenu": []
                },
                {
                  "menuKey": 14630408,
                  "parentMenuKey": 14630400,
                  "label": "District Graduate Count by School Year",
                  "desc": "Graduation counts by district and demographics for students.",
                  "iconStyle": "fas fa-user-graduate",
                  "url": "/report/report-card-data-district-graduate-count-by-school-year",
                  "moduleKey": 24,
                  "submenu": []
                },
                {
                  "menuKey": 14630409,
                  "parentMenuKey": 14630400,
                  "label": "State Graduate Count by School Year",
                  "desc": "Graduation counts for state by demographics for students.",
                  "iconStyle": "fas fa-user-graduate",
                  "url": "/report/report-card-data-state-graduate-count-by-school-year",
                  "moduleKey": 24,
                  "submenu": []
                }
              ]
            },
            {
              "menuKey": 14630500,
              "parentMenuKey": 14630000,
              "label": "Student Attendance",
              "desc": "Reports about Absenteeism and Attendance.",
              "iconStyle": "fas fa-school",
              "url": "",
              "moduleKey": 24,
              "submenu": [
                {
                  "menuKey": 14630501,
                  "parentMenuKey": 14630500,
                  "label": "School Attendance Rate with Student Disagg",
                  "desc": "Absenteeism and Attendance details by school by demographic.",
                  "iconStyle": "fas fa-school",
                  "url": "/report/report-card-data-school-attendance-rate-with-student-disagg",
                  "moduleKey": 24,
                  "submenu": []
                },
                {
                  "menuKey": 14630502,
                  "parentMenuKey": 14630500,
                  "label": "District Attendance Rate with Student Disagg",
                  "desc": "Absenteeism and Attendance details by district by demographic.",
                  "iconStyle": "fas fa-school",
                  "url": "/report/report-card-data-district-attendance-rate-with-student-disagg",
                  "moduleKey": 24,
                  "submenu": []
                },
                {
                  "menuKey": 14630503,
                  "parentMenuKey": 14630500,
                  "label": "State Attendance Rate with Student Disagg",
                  "desc": "Absenteeism and Attendance details for state by demographic.",
                  "iconStyle": "fas fa-school",
                  "url": "/report/report-card-data-state-attendance-rate-with-student-disagg",
                  "moduleKey": 24,
                  "submenu": []
                }
              ]
            },
            {
              "menuKey": 14630600,
              "parentMenuKey": 14630000,
              "label": "Test Result",
              "desc": "Reports about Ohio's State Tests.",
              "iconStyle": "fas fa-user-chart",
              "url": "",
              "moduleKey": 24,
              "submenu": [
                {
                  "menuKey": 14630601,
                  "parentMenuKey": 14630600,
                  "label": "School Test Results with Student Disagg",
                  "desc": "Test Result and Proficiency Level details by school by assessment by demographic.",
                  "iconStyle": "fas fa-user-chart",
                  "url": "/report/report-card-data-school-test-results-with-student-disagg",
                  "moduleKey": 24,
                  "submenu": []
                },
                {
                  "menuKey": 14630602,
                  "parentMenuKey": 14630600,
                  "label": "District Test Results with Student Disagg",
                  "desc": "Test Result and Proficiency Level details by district by assessment by demographic.",
                  "iconStyle": "fas fa-user-chart",
                  "url": "/report/report-card-data-district-test-results-with-student-disagg",
                  "moduleKey": 24,
                  "submenu": []
                },
                {
                  "menuKey": 14630603,
                  "parentMenuKey": 14630600,
                  "label": "State Test Results with Student Disagg",
                  "desc": "Test Result and Proficiency Level details for state by assessment by demographic.",
                  "iconStyle": "fas fa-user-chart",
                  "url": "/report/report-card-data-state-test-results-with-student-disagg",
                  "moduleKey": 24,
                  "submenu": []
                }
              ]
            },
            {
              "menuKey": 14630700,
              "parentMenuKey": 14630000,
              "label": "Value Added",
              "desc": "Reports about Value Added data.",
              "iconStyle": "fas fa-analytics",
              "url": "",
              "moduleKey": 24,
              "submenu": [
                {
                  "menuKey": 14630701,
                  "parentMenuKey": 14630700,
                  "label": "School Value Added 4th 8th Grade Subject Tests",
                  "desc": "Value Added growth determinations by school for 4th through 8th grade assessments by value added subgroup classifications.",
                  "iconStyle": "fas fa-analytics",
                  "url": "/report/report-card-data-school-value-added-4th-8th-grade-subject-tests",
                  "moduleKey": 24,
                  "submenu": []
                },
                {
                  "menuKey": 14630702,
                  "parentMenuKey": 14630700,
                  "label": "District Value Added 4th 8th Grade Subject Tests",
                  "desc": "Value Added growth determinations by district for 4th through 8th grade assessments by value added subgroup classifications.",
                  "iconStyle": "fas fa-analytics",
                  "url": "/report/report-card-data-district-value-added-4th-8th-grade-subject-tests",
                  "moduleKey": 24,
                  "submenu": []
                },
                {
                  "menuKey": 14630703,
                  "parentMenuKey": 14630700,
                  "label": "School Value Added End of Course Exams",
                  "desc": "Value Added growth determinations by school for End of Course assessments by value added subgroup classifications.",
                  "iconStyle": "fas fa-analytics",
                  "url": "/report/report-card-data-school-value-added-end-of-course-exams",
                  "moduleKey": 24,
                  "submenu": []
                },
                {
                  "menuKey": 14630704,
                  "parentMenuKey": 14630700,
                  "label": "District Value Added End of Course Exams",
                  "desc": "Value Added growth determinations by district for End of Course assessments by value added subgroup classifications.",
                  "iconStyle": "fas fa-analytics",
                  "url": "/report/report-card-data-district-value-added-end-of-course-exams",
                  "moduleKey": 24,
                  "submenu": []
                },
                {
                  "menuKey": 14630705,
                  "parentMenuKey": 14630700,
                  "label": "School Value Added Overall and Subject Composites",
                  "desc": "Value Added growth determinations by school for Overall and Subject Composites by value added subgroup classifications.",
                  "iconStyle": "fas fa-analytics",
                  "url": "/report/report-card-data-school-value-added-overall-and-subject-composites",
                  "moduleKey": 24,
                  "submenu": []
                },
                {
                  "menuKey": 14630706,
                  "parentMenuKey": 14630700,
                  "label": "District Value Added Overall and Subject Composites",
                  "desc": "Value Added growth determinations by district for Overall and Subject Composites by value added subgroup classifications.",
                  "iconStyle": "fas fa-analytics",
                  "url": "/report/report-card-data-district-value-added-overall-and-subject-composites",
                  "moduleKey": 24,
                  "submenu": []
                }
              ]
            },
            {
              "menuKey": 14630900,
              "parentMenuKey": 14630000,
              "label": "Improving At-Risk K3 Readers",
              "desc": "Reports about Improving At-Risk K3 Readers.",
              "iconStyle": "fas fa-book-reader",
              "url": "",
              "moduleKey": 24,
              "submenu": [
                {
                  "menuKey": 14630901,
                  "parentMenuKey": 14630900,
                  "label": "District Improving At Risk K 3 Reader ",
                  "desc": "Improving At-Risk K3 Reader results by district, cohort and demographics for students included in the Improving At-Risk Readers calculation.  ",
                  "iconStyle": "fas fa-book-reader",
                  "url": "/report/report-card-data-district-improving-at-risk-k-3-reader-",
                  "moduleKey": 24,
                  "submenu": []
                },
                {
                  "menuKey": 14630902,
                  "parentMenuKey": 14630900,
                  "label": "School Improving At Risk K 3 Reader ",
                  "desc": "Improving At-Risk K3 Reader results by district, cohort and demographics for students included in the Improving At-Risk Readers calculation.  ",
                  "iconStyle": "fas fa-book-reader",
                  "url": "/report/report-card-data-school-improving-at-risk-k-3-reader-",
                  "moduleKey": 24,
                  "submenu": []
                },
                {
                  "menuKey": 14630903,
                  "parentMenuKey": 14630900,
                  "label": "District Diagnostic Report",
                  "desc": "Reading Diagnostic results by district, grade level, and demographics for students taking or expected to take the assessment.",
                  "iconStyle": "fas fa-book-reader",
                  "url": "/report/report-card-data-district-diagnostic-report",
                  "moduleKey": 24,
                  "submenu": []
                },
                {
                  "menuKey": 14630904,
                  "parentMenuKey": 14630900,
                  "label": "School Diagnostic Report",
                  "desc": "Reading Diagnostic results by school, grade level, and demographics for students taking or expected to take the assessment.",
                  "iconStyle": "fas fa-book-reader",
                  "url": "/report/report-card-data-school-diagnostic-report",
                  "moduleKey": 24,
                  "submenu": []
                }
              ]
            },
            {
              "menuKey": 14631000,
              "parentMenuKey": 14630000,
              "label": "Teacher and Staff",
              "desc": "Reports about Early Learning data.",
              "iconStyle": "fas fa-user-chart",
              "url": "",
              "moduleKey": 24,
              "submenu": [
                {
                  "menuKey": 14631001,
                  "parentMenuKey": 14631000,
                  "label": "District Principal Report",
                  "desc": "Principal detail report by district.",
                  "iconStyle": "fas fa-chalkboard-teacher",
                  "url": "/report/report-card-data-district-principal-report",
                  "moduleKey": 24,
                  "submenu": []
                },
                {
                  "menuKey": 14631002,
                  "parentMenuKey": 14631000,
                  "label": "School Principal Report",
                  "desc": "Principal detail report by school.",
                  "iconStyle": "fas fa-chalkboard-teacher",
                  "url": "/report/report-card-data-school-principal-report",
                  "moduleKey": 24,
                  "submenu": []
                },
                {
                  "menuKey": 14631003,
                  "parentMenuKey": 14631000,
                  "label": "District Teacher Report",
                  "desc": "Teacher detail report by district.",
                  "iconStyle": "fas fa-chalkboard-teacher",
                  "url": "/report/report-card-data-district-teacher-report",
                  "moduleKey": 24,
                  "submenu": []
                },
                {
                  "menuKey": 14631004,
                  "parentMenuKey": 14631000,
                  "label": "School Teacher Report",
                  "desc": "Teacher detail report by school.",
                  "iconStyle": "fas fa-chalkboard-teacher",
                  "url": "/report/report-card-data-school-teacher-report",
                  "moduleKey": 24,
                  "submenu": []
                }
              ]
            },
            {
              "menuKey": 14631100,
              "parentMenuKey": 14630000,
              "label": "Early Learning",
              "desc": "Reports about Similar District data.",
              "iconStyle": "fas fa-user-chart",
              "url": "",
              "moduleKey": 24,
              "submenu": [
                {
                  "menuKey": 14631101,
                  "parentMenuKey": 14631100,
                  "label": "District Kindergarten Readiness",
                  "desc": "Ohio’s Local Report Card starts with any given district and identifies up to 20 districts that are most similar according to certain criteria.",
                  "iconStyle": "fas-chart-line",
                  "url": "/report/report-card-data-similar-districts",
                  "moduleKey": 24,
                  "submenu": []
                },
                {
                  "menuKey": 14631102,
                  "parentMenuKey": 14631100,
                  "label": "State Kindergarten Readiness",
                  "desc": "Proficiency Level details for state for Kindergarten Readiness by demographic.",
                  "iconStyle": "fas fa-user-chart",
                  "url": "/report/report-card-data-state-kindergarten-readiness",
                  "moduleKey": 24,
                  "submenu": []
                }
              ]
            }
          ]
        },
        {
          "menuKey": 14640000,
          "parentMenuKey": null,
          "label": "Career Tech Reports",
          "desc": "Reports about Career Tech Education data.",
          "iconStyle": "fas fa-chart-area",
          "url": "",
          "moduleKey": 24,
          "submenu": [
            {
              "menuKey": 14640100,
              "parentMenuKey": 14640000,
              "label": "Career Readiness Dashboard",
              "desc": "Reports about Career Tech Education data.",
              "iconStyle": "fas fa-chart-area",
              "url": "",
              "moduleKey": 24,
              "submenu": [
                {
                  "menuKey": 14640101,
                  "parentMenuKey": 14640100,
                  "label": "College Credit Attainment",
                  "desc": "Reports about Career Tech Education data.",
                  "iconStyle": "fas fa-chart-area",
                  "url": "/report/career-tech-college-credit-attainment-–-masked-version",
                  "moduleKey": 24,
                  "submenu": []
                },
                {
                  "menuKey": 14640102,
                  "parentMenuKey": 14640100,
                  "label": "Industry Recognized Credential Attainment",
                  "desc": "Reports about Career Tech Education data.",
                  "iconStyle": "fas fa-chart-area",
                  "url": "/report/career-tech-industry-recognized-credential-attainment-–-masked-version",
                  "moduleKey": 24,
                  "submenu": []
                },
                {
                  "menuKey": 14640103,
                  "parentMenuKey": 14640100,
                  "label": "Ohio Means Jobs Readiness Seal Attainment",
                  "desc": "Reports about Career Tech Education data.",
                  "iconStyle": "fas fa-chart-area",
                  "url": "/report/career-tech-ohio-means-jobs-readiness-seal-attainment-–-masked-version",
                  "moduleKey": 24,
                  "submenu": []
                }
              ]
            }
          ]
        },
        {
          "menuKey": 14650000,
          "parentMenuKey": null,
          "label": "Finance",
          "desc": "Reports about School Foundation Payments and Five Year Forecast.",
          "iconStyle": "fas fa-file-invoice-dollar",
          "url": "",
          "moduleKey": 24,
          "submenu": [
            {
              "menuKey": 14650100,
              "parentMenuKey": 14650000,
              "label": "Five Year Forecasts ",
              "desc": "Five-year forecast data submissions include three years of actual financial information and five years of projected financial performance including the current fiscal year.",
              "iconStyle": "fas fa-file-invoice-dollar",
              "url": "",
              "moduleKey": 24,
              "submenu": [
                {
                  "menuKey": 14650101,
                  "parentMenuKey": 14650100,
                  "label": "Five-year Forecast Submissions",
                  "desc": "Reports for Traditional and Joint Vocational School Districts.",
                  "iconStyle": "fas fa-file-invoice-dollar",
                  "url": "/report/finance-forecast-submissions",
                  "moduleKey": 24,
                  "submenu": []
                },
                {
                  "menuKey": 14650102,
                  "parentMenuKey": 14650100,
                  "label": "Cash Balance Analyses",
                  "desc": "Reports for Traditional and Joint Vocational School Districts.",
                  "iconStyle": "fas fa-file-invoice-dollar",
                  "url": "/report/finance-forecast-analytics",
                  "moduleKey": 24,
                  "submenu": []
                }
              ]
            },
            {
              "menuKey": 14650200,
              "parentMenuKey": 14650000,
              "label": "Foundation Payment Report",
              "desc": "Foundation Payment Report.",
              "iconStyle": "fas fa-file-invoice-dollar",
              "url": "/finance/foundation-payment-report",
              "moduleKey": 24,
              "submenu": []
            }
          ]
        },
        {
          "menuKey": 14700000,
          "parentMenuKey": null,
          "label": "Nonpublic Data",
          "desc": "Reports for nonpublic schools and homeschool students using academic, enrollment and scholarship data.",
          "iconStyle": "fas fa-file-chart-pie",
          "url": "",
          "moduleKey": 24,
          "submenu": [
            {
              "menuKey": 14700100,
              "parentMenuKey": 14700000,
              "label": "Enrollment",
              "desc": "Reports about Student Enrollment at Chartered Nonpublic Schools",
              "iconStyle": "fas fa-users-class",
              "url": "",
              "moduleKey": 24,
              "submenu": [
                {
                  "menuKey": 14700101,
                  "parentMenuKey": 14700100,
                  "label": "School Enrollment",
                  "desc": "Enrollment for a chartered nonpublic school.",
                  "iconStyle": "fas fa-analytics",
                  "url": "/report/nonpublic-data-school-enrollment",
                  "moduleKey": 24,
                  "submenu": []
                },
                {
                  "menuKey": 14700102,
                  "parentMenuKey": 14700100,
                  "label": "State Enrollment",
                  "desc": "Enrollment at chartered nonpublic schools at state level.",
                  "iconStyle": "fas fa-analytics",
                  "url": "/report/nonpublic-data-state-enrollment",
                  "moduleKey": 24,
                  "submenu": []
                }
              ]
            },
            {
              "menuKey": 14700200,
              "parentMenuKey": 14700000,
              "label": "Scholarship",
              "desc": "Reports about Scholarship data.",
              "iconStyle": "fas fa-graduation-cap",
              "url": "",
              "moduleKey": 24,
              "submenu": [
                {
                  "menuKey": 14700201,
                  "parentMenuKey": 14700200,
                  "label": "Scholarship Applicants",
                  "desc": "Scholarship applicants.",
                  "iconStyle": "fas fa-analytics",
                  "url": "/report/nonpublic-data-scholarship-applicants",
                  "moduleKey": 24,
                  "submenu": []
                },
                {
                  "menuKey": 14700202,
                  "parentMenuKey": 14700200,
                  "label": "District Scholarship Participants",
                  "desc": "Scholarship (paid) participants at district level.",
                  "iconStyle": "fas fa-award",
                  "url": "/report/nonpublic-data-district-scholarship-participants",
                  "moduleKey": 24,
                  "submenu": []
                },
                {
                  "menuKey": 14700203,
                  "parentMenuKey": 14700200,
                  "label": "Provider Scholarship Participants",
                  "desc": "Scholarship (paid) participants at provider level.",
                  "iconStyle": "fas fa-award",
                  "url": "/report/nonpublic-data-provider-scholarship-participants",
                  "moduleKey": 24,
                  "submenu": []
                },
                {
                  "menuKey": 14700204,
                  "parentMenuKey": 14700200,
                  "label": "State Scholarship Participants",
                  "desc": "Scholarship (paid) participants at state level.",
                  "iconStyle": "fas fa-award",
                  "url": "/report/nonpublic-data-state-scholarship-participants",
                  "moduleKey": 24,
                  "submenu": []
                },
                {
                  "menuKey": 14700205,
                  "parentMenuKey": 14700200,
                  "label": "Scholarship Payments",
                  "desc": "Scholarship payments.",
                  "iconStyle": "fas fa-file-invoice-dollar",
                  "url": "/report/nonpublic-data-scholarship-payments",
                  "moduleKey": 24,
                  "submenu": []
                },
                {
                  "menuKey": 14700206,
                  "parentMenuKey": 14700200,
                  "label": "Historical EdChoice Designated List",
                  "desc": "EdChoice Designated public schools for previous school years.",
                  "iconStyle": "far fa-clipboard-list-check",
                  "url": "/report/nonpublic-data-historical-ed-choice-designated-list",
                  "moduleKey": 24,
                  "submenu": []
                },
                {
                  "menuKey": 14700207,
                  "parentMenuKey": 14700200,
                  "label": "Current Ed Choice Designated List",
                  "desc": "EdChoice Designated public schools for current and upcoming school years.",
                  "iconStyle": "far fa-clipboard-list-check",
                  "url": "/report/nonpublic-data-current-ed-choice-designated-list",
                  "moduleKey": 24,
                  "submenu": []
                },
                {
                  "menuKey": 14700208,
                  "parentMenuKey": 14700200,
                  "label": "Jon Peterson Special Needs Report",
                  "desc": "Jon Peterson Special Needs Board Report",
                  "iconStyle": "fas fa-books",
                  "url": "/report/nonpublic-data-jon-peterson-special-needs-report",
                  "moduleKey": 24,
                  "submenu": []
                },
                {
                  "menuKey": 14700209,
                  "parentMenuKey": 14700200,
                  "label": "Scholarship Assessment Report",
                  "desc": "Aggregated scores for scholarship students.",
                  "iconStyle": "fas fa-pencil",
                  "url": "/report/nonpublic-data-scholarship-assessment-report",
                  "moduleKey": 24,
                  "submenu": []
                }
              ]
            },
            {
              "menuKey": 14700300,
              "parentMenuKey": 14700000,
              "label": "Staff",
              "desc": "Reports about Principals, Teachers and Other Staff.",
              "iconStyle": "fas fa-chalkboard-teacher",
              "url": "",
              "moduleKey": 24,
              "submenu": [
                {
                  "menuKey": 14700301,
                  "parentMenuKey": 14700300,
                  "label": "Staff Counts",
                  "desc": "Nonpublic staff counts.",
                  "iconStyle": "fas fa-chalkboard-teacher",
                  "url": "/report/nonpublic-data-staff-counts",
                  "moduleKey": 24,
                  "submenu": []
                }
              ]
            },
            {
              "menuKey": 14700400,
              "parentMenuKey": 14700000,
              "label": "Homeschool",
              "desc": "Reports about homeschool students",
              "iconStyle": "fas fa-home",
              "url": "",
              "moduleKey": 24,
              "submenu": [
                {
                  "menuKey": 14700401,
                  "parentMenuKey": 14700400,
                  "label": "Homeschool Student Counts",
                  "desc": "Homeschool student counts.",
                  "iconStyle": "fas fa-home",
                  "url": "/report/nonpublic-data-homeschool-student-counts",
                  "moduleKey": 24,
                  "submenu": []
                }
              ]
            }
          ]
        }
      ]
    }
  ]
}
